import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Preis')

export default {
  label: 'Preis',
  route: 'preis',
  fields: [
    Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'),
    Filter.kumuliert(),
    Filter.Number('verleihungsJahr', 'calendar-o'),
    Filter.ReferenceByMultiValueSearchRep('preisTraeger', 'user', 'abstractPerson'),
    Filter.String('namePreis'),
    Filter.ReferenceBySearchRep('preisBezeichnung', 'folder-open'),
    {
      label: 'Preis.list.filter.hatPreisgeld',
      field: 'hatPreisgeld',
      type: 'select',
      translatable: true,
      values: [
        {
          value: 'TRUE',
          label: 'Preis.hatPreisgeld.TRUE'
        },
        {
          value: 'FALSE',
          label: 'Preis.hatPreisgeld.FALSE'
        },
        {
          value: null,
          label: ''
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/PreisFilter.js